import { leadStory, shortcuts } from "@/mocks/homeData";

export default function HeroLead() {
  return (
    <section id="top" className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-8 md:px-8 md:py-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_400px] lg:items-center">
          <div className="reveal">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                {leadStory.category}
              </span>
              <span className="rounded-full border border-background-300 px-3 py-1 text-xs text-foreground-600">
                全站已收录 312 份公开材料
              </span>
            </div>

            <h2 className="mt-4 font-heading text-3xl font-black leading-snug tracking-tight text-foreground-950 md:text-5xl md:leading-[1.2]">
              {leadStory.title}
            </h2>

            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              {leadStory.summary}
            </p>

            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <a
                href="#timeline"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-timeline-view h-4 w-4" style={{ lineHeight: 1 }} />
                看完整时间线
              </a>
              <a
                href="#analysis"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-file-search-line h-4 w-4" style={{ lineHeight: 1 }} />
                看细节分析
              </a>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-x-8 gap-y-4 border-t border-background-200 pt-5">
              {leadStory.stats.map((stat) => (
                <div key={stat.label} className="flex items-baseline gap-2">
                  <span className="font-label text-2xl font-bold text-primary-600 md:text-3xl">
                    {stat.value}
                  </span>
                  <span className="text-xs text-foreground-500 md:text-sm">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal lg:justify-self-end">
            <div className="relative w-full overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:w-[400px]">
              <div className="h-56 w-full md:h-64">
                <img
                  src="https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20stacked%20documents%20torn%20paper%20notes%20and%20a%20red%20thread%20connecting%20clues%20on%20a%20warm%20cream%20desk%20moody%20side%20lighting%20cinematic%20top%20down%20composition%20muted%20amber%20and%20charcoal%20tones%20subtle%20film%20grain%20investigative%20journalism%20mood%20no%20text%20no%20faces&width=1000&height=720&seq=heiliaodagua-lead-01&orientation=landscape"
                  alt="黑料大瓜主线瓜料细节分析配图"
                  title="黑料大瓜 细节分析 完整时间线"
                  className="h-full w-full object-top"
                />
              </div>
              <div className="flex items-center justify-between gap-3 px-4 py-3">
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className="ri-flashlight-fill text-base" style={{ lineHeight: 1 }} />
                  </span>
                  <span className="text-xs text-foreground-600 md:text-sm">主线追踪已开启</span>
                </div>
                <span className="font-label text-xs text-foreground-400">更新于 10 分钟前</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full border-t border-background-200 bg-background-50">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {shortcuts.map((item, index) => (
            <a
              key={item.label}
              href="#analysis"
              className={`group flex cursor-pointer items-center gap-3 px-4 py-4 transition-colors hover:bg-primary-50 md:px-8 ${
                index !== shortcuts.length - 1 ? "border-b border-background-200 lg:border-b-0 lg:border-r" : ""
              }`}
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${item.icon} text-lg`} style={{ lineHeight: 1 }} />
              </span>
              <span className="flex min-w-0 flex-col">
                <span className="text-sm font-medium text-foreground-900">{item.label}</span>
                <span className="truncate text-xs text-foreground-500">{item.desc}</span>
              </span>
              <i
                className="ri-arrow-right-s-line ml-auto h-5 w-5 shrink-0 text-foreground-300 transition-colors group-hover:text-primary-600"
                style={{ lineHeight: 1 }}
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}